<nz-spin [nzSpinning]="isSpinning">
  <div class="sales-portal-container">
    <div class="turnover-detail">
      <div class="detail-setting-header">
        <nz-breadcrumb>
          <nz-breadcrumb-item (click)="navigate('/sales-portal/workshop-acquisition')" style="cursor: pointer">Workshop
            Acquisition Overview
          </nz-breadcrumb-item>
          <nz-breadcrumb-item>Settings</nz-breadcrumb-item>
        </nz-breadcrumb>
        <div class="title">Workshop Acquisition Settings</div>
        <div class="key-value-box">
          <div class="key-value-item">
            <div class="key">Dealer Code</div>
            <div class="value ml20">{{ detailInfo.dealerCode }}</div>
          </div>
          <div class="key-value-item">
            <div class="key">Dealer Name</div>
            <div class="value ml20">{{ detailInfo.dealerName }}</div>
          </div>
          <div class="key-value-item">
            <div class="key">Target Year</div>
            <div class="value ml20">{{ detailInfo.targetYear }}</div>
          </div>
          <div class="divider"></div>
          <div class="key-value-item">
            <div class="value">Workshop Acquisition Target</div>
            <div class="key ml20 flex-center">
              <div style="width: 120px">
                <sales-portal-input-number
                  [disabled]="editStatus"
                  [(ngModel)]="detailInfo.targetCustomer"
                  [maxFractionDigits]="0"
                  [minFractionDigits]="0"
                ></sales-portal-input-number>
              </div>
              <svg-icon
                *ngIf="!editStatus"
                iconName="sales-portal-edit.svg"
                style="margin-left: 5px;"
                (click)="editTargetProcurement = true" [size]="14"></svg-icon>
            </div>
          </div>
          <div class="key-value-item">
            <div class="value">Remaining</div>
            <div class="key ml20">
              <span>{{ salesPortalService.formatThousands(workshopRemaining) }}</span>
            </div>
          </div>
        </div>
      </div>


      <!-- title -->
      <div class="title-section" style="margin-top: 40px">
        <div class="title">
          <span>Splitting Customer Quantity</span>
        </div>
        <button nz-button nzType="primary" (click)="handleEdit()" *ngIf="!editStatus">Edit</button>
      </div>

      <!-- View Mode-->
      <div *ngIf="!editStatus" class="filter-table-section" style="margin-top: 20px">
        <product-group-table
          tableType="workshop-acquisition"
          [tableData]="detailInfo.customerConfigurationList"
          [classificationMethod]="detailInfo.classificationMethod"
          [year]="detailInfo.targetYear"
          [timeMode]="detailInfo.expandCustomerSplitMethod"
          [splittingMethod]="splittingMethod"
          [targetAmount]="detailInfo.targetCustomer"
          [disableEdit]="true"
        >
        </product-group-table>
      </div>
      <!-- Edit Mode -->
      <div *ngIf="editStatus">
        <div style="display: flex;margin-top: 10px">
          <nz-form-item class="search-form-item">
            <nz-form-label>Splitting Method</nz-form-label>
            <nz-form-control class="line">
              <nz-select style="width: 200px"
                         [nzSuffixIcon]="suffixSearch"
                         [(ngModel)]="splittingMethod"
              >
                <nz-option nzValue="manualSplitting" nzLabel="Manual Splitting"></nz-option>
                <nz-option nzValue="automaticallySplitting" nzLabel="Automatically Splitting"></nz-option>
              </nz-select>
              <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item class="search-form-item" style="margin-left: 20px">
            <nz-form-label>Time</nz-form-label>
            <nz-form-control class="line">
              <nz-select style="width: 200px" [nzSuffixIcon]="suffixSearch"
                         [(ngModel)]="time"
                         (ngModelChange)="handleTimeChange()">
                <nz-option nzValue="BY_YEAR" nzLabel="Year"></nz-option>
                <nz-option nzValue="BY_QUARTER" nzLabel="Quarter"></nz-option>
                <nz-option nzValue="BY_MONTH" nzLabel="Month"></nz-option>
              </nz-select>
              <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div *ngIf="time === 'BY_QUARTER'">
          <product-group-table
            tableType="workshop-acquisition"
            [tableData]="detailInfo.customerConfigurationList"
            [classificationMethod]="detailInfo.classificationMethod"
            [timeMode]="'BY_QUARTER'"
            [splittingMethod]="splittingMethod"
            [targetAmount]="detailInfo.targetCustomer"
            [detailInfo]="detailInfo"
          >
          </product-group-table>
        </div>

        <div *ngIf="time === 'BY_MONTH'">
          <product-group-table
            tableType="workshop-acquisition"
            [tableData]="detailInfo.customerConfigurationList"
            [classificationMethod]="detailInfo.classificationMethod"
            [timeMode]="'BY_MONTH'"
            [splittingMethod]="splittingMethod"
            [targetAmount]="detailInfo.targetCustomer"
            [detailInfo]="detailInfo"
          >
          </product-group-table>
        </div>

        <div *ngIf="time === 'BY_YEAR'">
          <product-group-table
            tableType="workshop-acquisition"
            [tableData]="detailInfo.customerConfigurationList"
            [classificationMethod]="detailInfo.classificationMethod"
            [year]="detailInfo.targetYear"
            [timeMode]="'BY_YEAR'"
            [splittingMethod]="splittingMethod"
            [targetAmount]="detailInfo.targetCustomer"
            [detailInfo]="detailInfo"
          >
          </product-group-table>
        </div>
      </div>


      <!--Last Step & Save-->
      <div class="last-step-and-save" *ngIf="editStatus && time">
        <button nz-button nzType="default" (click)="handleCancel()">
          Cancel
        </button>
        <button nz-button nzType="primary" (click)="handleSave()" style="margin-left: 10px">Save</button>
      </div>
    </div>

  </div>
</nz-spin>


